<template>
  <div class="landing-card">
    <div class="landing-card__image">
      <img
        loading="lazy"
        alt=""
        :src="imageSrc"
      >
    </div>
    <div class="landing-card__description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'LandingCard',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

.landing-card {
  max-width: 308px;

  &__image {
    margin-bottom: 16px;
    height: 288px;

    @include media-lg() {
      margin-bottom: 40px;
    }

    img {
      height: 100%;
      width: 100%;
      border-radius: 24px;
      object-fit: cover;
    }
  }

  &__description {
    margin: 0 auto;
    max-width: 205px;

    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    text-align: center;

    @include media-lg() {
      max-width: 230px;

      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
    }
  }
}

</style>
